/**
 * Decodifica o payload de um JWT sem verificar assinatura.
 * Retorna null se o token for inválido ou ausente.
 */
const decodeJwt = (token) => {
  try {
    const finalToken =
      token ||
      localStorage.getItem("token") || // ajuste a chave se for diferente
      null;

    if (!finalToken || typeof finalToken !== "string") return null;

    const parts = finalToken.split(".");
    if (parts.length !== 3) return null;

    const base64 = parts[1]
      .replace(/-/g, "+")
      .replace(/_/g, "/");

    const padded = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      "="
    );

    const jsonStr = atob(padded);
    return JSON.parse(jsonStr);
  } catch {
    return null;
  }
};

/**
 * Retorna true se o token estiver expirado ou inválido.
 */
export const isTokenExpired = (token) => {
  const payload = decodeJwt(token);
  if (!payload?.exp) return true;
  return Date.now() >= payload.exp * 1000;
};

/**
 * Retorna o token armazenado no localStorage.
 */
export const getStoredToken = () => {
  try {
    const user = JSON.parse(localStorage.getItem("user"));
    return user?.token ?? null;
  } catch {
    return null;
  }
};

export default decodeJwt;
